import styled from 'styled-components';

export const StyledContainer = styled.div`
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 0 0 3px #d0d0e4;
  background-color: #f5f5f5;

  &.protected-container--locked {
    box-shadow: 0 0 0 3px #e4d0d0;
  }
`;

export const StyledHeader = styled.div`
  width: 75%;
  color: #777777;
  background-color: #d0d0e4;
  padding: 8px;
  text-align: center;
  margin: 0 auto;
  border-radius: 8px;

  &.protected-container__locked-header {
    background-color: #e4d0d0;
  }
`;
